import { z } from "zod";

export const siteReportTypeSchema = z
  .enum(["conversion", "health", "speed", "accessibility", "aeoSeo"])
  .describe("SiteReportType");

export const SITE_REPORT_TYPE_LABELS: Record<
  z.infer<typeof siteReportTypeSchema>,
  string
> = {
  conversion: "Conversion",
  health: "Health",
  speed: "Speed",
  accessibility: "Accessibility",
  aeoSeo: "AEO & SEO",
};
